type ManagerLike = {
  userFIO?: string;
  lastName?: string;
  firstName?: string;
  patronymic?: string;
  userLogin?: string;
};

export const formatManagerFio = (manager?: ManagerLike): string => {
  if (!manager) return '';
  if (manager.userFIO) return manager.userFIO;

  const parts = [manager.lastName, manager.firstName, manager.patronymic].filter(Boolean);
  if (parts.length) return parts.join(' ');

  return manager.userLogin ?? '';
};
